import { AdminReportsService } from '../../../../../services/admin-reports.service'
import { handleExport } from '../../../../../actions/export-report.actions'

const exportData = params =>
	handleExport(
		params,
		`${AdminReportsService.baseURL}/exportar-clube-moveflex`,
		'relatorio-clube-moveflex.csv'
	)

export const clubReportActions = { exportData }
